import { EnderecoDTO } from "./enderecoDTO";
export class GerenteDTO {

  public promotora!: number; 
  public idsRegionais?: (string|number)[];
  public idsComerciais?: (string|number)[];
  public idsPontosDeVenda?: (string|number)[];

  public id!: string | null;
  public ativo!: boolean;
  public nome!: string;
  public cpf!: string;
  public email!: string;
  public cidade?: string;
  public numeroCertificacao!: string;
  public enderecoDTO!: EnderecoDTO | undefined;
  public telefoneComercial!: string;
  public telefoneCelular!: string;
  public codigoExterno!: string;
  public nomePromotora?: string;
  public nomesRegionais?: string;
  public nomesComerciais?: string; 
  public nomesPontoDeVenda?: string;
  
}